import { atom } from "recoil";

export const recentExternalLink = atom({
  key: "recentExternalLink",
  default: "",
});
